export default __webpack_public_path__ + "static/media/bogota.f3365599.png";